import React, { useCallback } from 'react'
import { navigate } from 'gatsby'
import {
  Wrapper,
  LogoLink,
  Shadow
} from './index.styled'
import Logo, { LOGO_TITLE } from 'components/logo'
import Button from 'components/ui-elements/button'
import { useAppLayout } from 'layouts/main'

const MOBILE_PILL = { width: 63, height: 21, fontSize: 12 }

const Header = () => {
  const { showSplash, setShowSplash, scrollToInquire } = useAppLayout()

  const onLogoClick = useCallback((event) => {
    event.preventDefault()
    if (window.location.pathname === '/') {
      setShowSplash(true)
      return
    }
    navigate('/')
  }, [setShowSplash])

  const onInquireClick = useCallback(() => {
    if (scrollToInquire?.current) {
      scrollToInquire.current()
      return
    }
    navigate('/#inquire')
  }, [scrollToInquire])

  return (
    <Wrapper $hidden={showSplash}>
      <LogoLink href='/' onClick={onLogoClick} aria-label={LOGO_TITLE}>
        <Logo variant='chrome' width={112} mobileWidth={94} />
      </LogoLink>
      <Button as='button' onClick={onInquireClick} mobile={MOBILE_PILL}>Inquire</Button>
      <Shadow />
    </Wrapper>
  )
}

export default Header
